/* eslint-disable no-use-before-define */
/* eslint-disable no-promise-executor-return */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  badges: [],
  url: '',
};

// Actual Slice
export const LayoutSlice = createSlice({
  name: 'Layout',
  initialState,
  reducers: {
    // Action to set the badges status
    setBadgesState(state, action) {
      state.badges = action.payload;
    },

    setLayoutUrl(state, action) {
      state.url = action.payload;
    },

    // Clears the newsletters sidebar badge as soon as the feed is opened,
    // without waiting for the next badges poll.
    clearNewslettersBadge(state) {
      state.badges = { ...state.badges, new_newsletters_count: 0 };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setBadgesAsync.fulfilled, (state, action) => {
      state.badges = action.payload;
    });
  },
});

export const { setBadgesState, setLayoutUrl, clearNewslettersBadge } =
  LayoutSlice.actions;

export const selectBadgesState = (state) => state.LayoutSlice.badges;
// Thunks
const delay = () => new Promise((resolve) => setTimeout(resolve, 1000));

export const setBadgesAsync = createAsyncThunk(
  'layout/badgesAsync',
  async (badges) => {
    await delay();
    return badges;
  }
);

export default LayoutSlice.reducer;
